// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/uae-dirham-symbol.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "UAESymbol";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}

.currency-symbol {
  display: inline-block;
  margin-left: 5px;
  margin-right: 5px;
  vertical-align: middle;
  line-height: 1;
  font-size: 1.001em;
}

.currency-symbol .icon-saudi_riyal {
  display: inline-block;
  vertical-align: middle;
}

.currency-symbol .icon-saudi_riyal::before {
  font-size: inherit;
  vertical-align: middle;
}

.dirham-symbol {
  font-family: "UAESymbol";
  font-size: inherit;
  vertical-align: middle;
}
`, "",{"version":3,"sources":["webpack://./src/assets/dirham-symbol.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,+DAA4D;EAC5D,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,sBAAsB;AACxB","sourcesContent":["@font-face {\n  font-family: \"UAESymbol\";\n  src: url(\"./fonts/uae-dirham-symbol.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n.currency-symbol {\n  display: inline-block;\n  margin-left: 5px;\n  margin-right: 5px;\n  vertical-align: middle;\n  line-height: 1;\n  font-size: 1.001em;\n}\n\n.currency-symbol .icon-saudi_riyal {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.currency-symbol .icon-saudi_riyal::before {\n  font-size: inherit;\n  vertical-align: middle;\n}\n\n.dirham-symbol {\n  font-family: \"UAESymbol\";\n  font-size: inherit;\n  vertical-align: middle;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
